// The desktop app's document robot, when this app runs inside it.
//
// aloha.desktop.shell exposes `window.alohaDesktop.seao` (its
// docs/api-documentation.md): sign in to SEAO, download a notice's documents,
// and hand each file back so this page uploads it with its own session. In a
// browser there is no such object, and everything here says "not available".

const SEAO_NOTICE =
  /^https:\/\/seao\.gouv\.qc\.ca\/avis-resultat-recherche\/consulter\?(?:.*&)?ItemId=[0-9a-f-]{36}(?:&|$)/i;

/** The robot, or null outside the desktop app. */
export function desktopSeaoRobot() {
  const desktop = typeof window !== 'undefined' ? window.alohaDesktop : undefined;
  return (desktop && desktop.seao) || null;
}

/** Whether a tender's source URL is a SEAO notice the robot can take. */
export function isSeaoNoticeUrl(url) {
  return typeof url === 'string' && SEAO_NOTICE.test(url);
}

// Same comparison as the opportunity page's missing-documents check
// (PageOpportunityDetails): a file name loses its extension, then both sides
// are trimmed and lowercased. So a document uploaded under its title stops
// being reported missing.
export function normalizeTitle(title) {
  return String(title || '')
    .trim()
    .toLowerCase();
}

export function normalizeName(name) {
  return normalizeTitle(String(name || '').replace(/\.[^/.]+$/, ''));
}

/**
 * The name to upload a document under: its SEAO title, with the file's
 * extension. Only path separators are replaced, so the title still matches.
 */
export function uploadName(title, fileName) {
  const ext = (/\.[^/.]+$/.exec(fileName || '') || [''])[0];
  const base =
    String(title || '')
      .replace(/[\\/]+/g, '-')
      .trim() || 'document';
  return `${base}${ext}`;
}

/** The robot's downloaded documents the opportunity doesn't have yet. */
export function documentsToUpload(robotDocuments, opportunityDocuments) {
  const have = new Set((opportunityDocuments || []).map((d) => normalizeName(d && d.name)));
  return (robotDocuments || []).filter((d) => d.downloaded && !d.restricted && !have.has(normalizeTitle(d.title)));
}
